export default __webpack_public_path__ + "static/media/shangpin.b7c957f1.png";